import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';

class TuiStringifyContentPipe {
    transform(stringify) {
        return ({ $implicit }) => stringify($implicit);
    }
}
TuiStringifyContentPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiStringifyContentPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TuiStringifyContentPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiStringifyContentPipe, name: "tuiStringifyContent" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiStringifyContentPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tuiStringifyContent',
                }]
        }] });

class TuiStringifyContentPipeModule {
}
TuiStringifyContentPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiStringifyContentPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiStringifyContentPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiStringifyContentPipeModule, declarations: [TuiStringifyContentPipe], exports: [TuiStringifyContentPipe] });
TuiStringifyContentPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiStringifyContentPipeModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiStringifyContentPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiStringifyContentPipe],
                    exports: [TuiStringifyContentPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiStringifyContentPipe, TuiStringifyContentPipeModule };
